import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { DynamicFormComponent } from './dynamic-form.component';
import { GenerateAutocompleteInputComponent } from './generate-autocomplete-input/generate-autocomplete-input.component';
import { GenerateAutocompleteMultiSelectInputComponent } from './generate-autocomplete-multiselect-input/generate-autocomplete-multiselect-input.component';
import { GenerateDatapickerOnlyYearAndMonthInputComponent } from './generate-datapicker-only-year-and-month-input/generate-datapicker-only-year-and-month-input.component';


@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [DynamicFormComponent,
    GenerateAutocompleteInputComponent,
    GenerateAutocompleteMultiSelectInputComponent,
    GenerateDatapickerOnlyYearAndMonthInputComponent
  ],
  providers: [],
  exports:[
    DynamicFormComponent,
    FormsModule,
    ReactiveFormsModule,
    GenerateAutocompleteInputComponent,
    GenerateAutocompleteMultiSelectInputComponent,
    GenerateDatapickerOnlyYearAndMonthInputComponent
  ]
})
export class DynamicFormModule { }
